<template>
      <section class="process">
      <h1 class="heading">
        Specialisaties
      </h1>
      <div class="box-container container">
        <div class="box">
          <img src="../assets/images/process-img-2.png" alt="Aligner behandeling voor rechte tanden bij Tandzorg Gestel">
          <h3>Aligner Behandelingen</h3>
          <p>Voor wie op zoek is naar een subtiele manier om tanden recht te zetten, bieden wij moderne aligner behandelingen met SureSmile. Dankzij nauwkeurige digitale planning en 3D-scans sluiten de aligners goed aan en verloopt uw behandeling stap voor stap op een voorspelbare manier. U krijgt vooraf een duidelijk beeld van het verwachte eindresultaat, met het gemak dat de aligners eenvoudig te verwijderen zijn tijdens eten en tandenpoetsen.</p>
        </div>
        <div class="box">
          <img src="../assets/images/process-img-1.png" alt="Zorgvuldige behandeling van angstpatiënten bij Tandzorg Gestel">
          <h3>Zorg voor patiënten met tandartsangst</h3>
          <p>Wij begrijpen dat een tandartsbezoek voor sommige patiënten spannend kan zijn. Met onze speciale aanpak voor angstpatiënten bieden wij rustgevende technieken en een persoonlijke, empathische benadering, zodat elke behandeling in een ontspannen sfeer plaatsvindt.</p>
        </div>
        <div class="box">
          <img src="../assets/images/process-img-3.png" alt="Cosmetische tandheelkunde voor een stralende glimlach">
          <h3>Cosmetische Tandheelkunde</h3>
          <p>Een stralende glimlach draagt bij aan zelfvertrouwen. Onze cosmetische behandelingen, zoals tanden bleken, facings en kroonwerk, helpen u uw glimlach te verfraaien met behoud van een natuurlijke uitstraling.</p>
        </div>
      </div>
    </section>
</template>

<script>
export default {
name: "ProcessSection"
}
</script>

<style scoped>
.process .box-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
  gap: 2rem;
}
.process .box-container .box {
  background-color: var(--blue);
  padding: 2rem;
  border-radius: .5rem;
  text-align: center;
  box-shadow: var(--box-shadow);
}
.process .box-container .box img {
  height: 20rem;
  margin: 1rem 0;
}
.process .box-container .box h3 {
  font-size: 2rem;
  color: var(--white);
  margin: 1.5rem 0;
}
.process .box-container .box p {
  font-size: 1.5rem;
  color: var(--white);
  line-height: 2;
}
</style>